"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _AnimatorParent = _interopRequireDefault(require("./components/AnimatorParent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _AnimatorParent["default"];
exports["default"] = _default;